import { render, staticRenderFns } from "./CheckoutPage.vue?vue&type=template&id=b5a70c20&scoped=true"
import script from "./CheckoutPage.vue?vue&type=script&lang=js"
export * from "./CheckoutPage.vue?vue&type=script&lang=js"
import style0 from "./CheckoutPage.vue?vue&type=style&index=0&id=b5a70c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a70c20",
  null
  
)

export default component.exports